import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed, onMounted, onUnmounted, ref } from 'vue';
import utils from '@/utils';
import { GridCardSectionProps } from '@/types/components/grid-card-section';
import GridCardSectionDesktop from '@/component-sections/GridCardSection/GridCardSectionDesktop.vue';
import GridCardSectionMobile from '@/component-sections/GridCardSection/GridCardSectionMobile.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GridCardSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const sectionRef = ref<HTMLElement | null>(null);
const headerRef = ref<HTMLElement | null>(null);
const contentRef = ref<HTMLElement | null>(null);
const isHeaderVisible = ref(false);
const isContentVisible = ref(false);

const cards = computed<any[]>(() => {
  const list = utils.sc.getFieldObj(fields.value, 'cards');
  return Array.isArray(list) ? list : [];
});

const normalizeBoolean = (raw: unknown) => {
  if (typeof raw === 'boolean') return raw;
  if (typeof raw === 'number') return raw === 1;
  if (typeof raw === 'string') return ['1', 'true', 'yes', 'on'].includes(raw.toLowerCase());
  return false;
};

const normalizeCount = (raw: unknown, fallback: number) => {
  const parsed = Number.parseInt(String(raw), 10);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(Math.max(parsed, 1), 4);
};

const isCarousel = computed(() =>
  normalizeBoolean(utils.sc.getFieldObj(fields.value, 'isCarousel')?.value)
);

const desktopColumnCount = computed(() => {
  const raw = utils.sc.getSpVal(fields.value, 'desktopColumnCount');
  return normalizeCount(raw, 2);
});

const mobileCardsPerPage = computed(() => {
  const raw = utils.sc.getSpVal(fields.value, 'mobileCarsPerPage');
  return normalizeCount(raw, 1);
});

const instanceKey = computed(() =>
  String(props.rendering?.uid || props.dataSource || 'gcs').replace(/[^a-zA-Z0-9_-]/g, '')
);

let headerObserver: IntersectionObserver | null = null;
let contentObserver: IntersectionObserver | null = null;

onMounted(() => {
  if (headerRef.value) {
    headerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isHeaderVisible.value = entry.isIntersecting;
        });
      },
      { threshold: 0.1 }
    );
    headerObserver.observe(headerRef.value);
  }

  if (contentRef.value) {
    contentObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isContentVisible.value = entry.isIntersecting;
        });
      },
      { threshold: 0.1 }
    );
    contentObserver.observe(contentRef.value);
  }
});

onUnmounted(() => {
  if (headerObserver) headerObserver.disconnect();
  if (contentObserver) contentObserver.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(_ctx.$style['c-grid-card-section']),
        ref_key: "sectionRef",
        ref: sectionRef
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style['c-grid-card-section__inner'])
            }, [
              _createElementVNode("header", {
                ref_key: "headerRef",
                ref: headerRef,
                class: _normalizeClass([
            _ctx.$style['c-grid-card-section__header'],
            isHeaderVisible.value && _ctx.$style['c-grid-card-section__header--revealed'],
          ])
              }, [
                (_unref(utils).sc.getFieldValue(fields.value, 'sectionTitle', 'Resources'))
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 0,
                      class: _normalizeClass(_ctx.$style['c-grid-card-section__title'])
                    }, _toDisplayString(_unref(utils).sc.getFieldValue(fields.value, 'sectionTitle', 'Resources')), 3))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.$style['c-grid-card-section__subtitle'])
                }, _toDisplayString(_unref(utils).sc.getFieldValue(
                fields.value,
                'sectionSubtitle',
                'Access technical documentation, catalogs, and guides'
              )), 3)
              ], 2),
              _createElementVNode("div", {
                ref_key: "contentRef",
                ref: contentRef,
                class: _normalizeClass([
            _ctx.$style['c-grid-card-section__content'],
            isContentVisible.value && _ctx.$style['c-grid-card-section__content--revealed'],
          ])
              }, [
                _createVNode(GridCardSectionDesktop, {
                  cards: cards.value,
                  "is-carousel": isCarousel.value,
                  "desktop-column-count": desktopColumnCount.value,
                  "instance-key": instanceKey.value
                }, null, 8, ["cards", "is-carousel", "desktop-column-count", "instance-key"]),
                _createVNode(GridCardSectionMobile, {
                  cards: cards.value,
                  "is-carousel": isCarousel.value,
                  "mobile-cards-per-page": mobileCardsPerPage.value,
                  "instance-key": instanceKey.value
                }, null, 8, ["cards", "is-carousel", "mobile-cards-per-page", "instance-key"])
              ], 2)
            ], 2)
          ]),
          _: 1
        })
      ], 2))
    : _createCommentVNode("", true)
}
}

})